t = require('app/scripts/views/internal/teacup-with-helpers')('atMention')

module.exports = ->
  t.span { class: 'atMention' + t.mustacheBlock('isMe', (-> ' me')), title: t.mustacheVar('fullName') }, ->
    t.text t.mustacheVar('atMention')
